import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AttachmentDto, CustomValue, Documento, MetadatoTipologiaDto, TipologiadetailDto } from '../models/data.model';
import { AuthGuardService } from '../services/authGuard';
import { CommonService } from '../services/common.service';
import { DataService } from '../services/data.service';
import { FileService } from '../services/file.service';
// import { LegalEntityService } from '../services/legal-entity.service';
import { MimetypeService } from '../services/mimetype.service';
import { PresaVisioneModalService } from '../services/presa-visione-modal.service';

@Component({
  selector: 'app-international-activities',
  templateUrl: './international-activities-detail.component.html',
  styleUrls: ['./international-activities-detail.component.css']
}
)

export class InternationalActivitiesdetailComponent implements OnInit {

  @ViewChild('DynamicForm') DynamicFormElement;
  @ViewChild('DynamicInput') DynamicInputElement;
  Rank = [1, 2, 3, 4, 5];
  PasswordAllegato: string = '';
  RichiediPassword: boolean;
  placeholder: string = 'Password';
  DocAttesa: Documento;
  AllegatoDtoAttesa: AttachmentDto;
  //se false visualizza, se true scarica
  ArcaOperazione: boolean;
  starList: boolean[] = [true, true, true, true, true];
  rating: number;
  setStar(data: any) {
    this.rating = data + 1;
    for (var i = 0; i <= 4; i++) {
      if (i <= data) {
        this.starList[i] = false;
      }
      else {
        this.starList[i] = true;

      }
    }
  }

  constructor(private tipologiService: FileService,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private tipologiaService: CommonService<TipologiadetailDto>,
    private distinctValueService: CommonService<CustomValue>,
    private documentService: CommonService<Documento>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private authService: AuthGuardService,
    private router: Router,
    private formBuilder: FormBuilder,
    // private legalEntityService: LegalEntityService,
    private presaVisioneModalService: PresaVisioneModalService) {

      this.checkIfLogin();
  }

  inviaFeed(): void {
    this.MemorizzaFeedbackConsultazione(this.id, this.idallegato)
    //inserisci un aggiorna pagina
    this.router.navigate(['/']);
  }

  MemorizzaFeedbackConsultazione(iddocumento, idallegato) {
    let url = 'api/rest/MemorizzaFeedbackConsultazione';
    let input = {
      idutente: this.idutente, iddocumento: iddocumento,
      idallegato: idallegato, valorefeedback: this.rating };
    this.documentService.postData(url, input, false).subscribe(result => {
      // console.log('Setflaglettura esguito: ' + result);
    }, error => console.error('error ', error));
  }

  isUtenteChiamante = true;
  document: Documento;
  loaded = false;
  isPreset = false;
  loadedLogin = false;
  id: string;
  idallegato: string;
  idutente: string;

  selected: any = {
    item: null,
    model: null,
    classification: null
  }
  isUserloggedIn: boolean = false;
  public profile: any = null;

/* Evolutive Maggio Giugno Luglio 2021: Cliccando sul link della notifica si arriva al direttamente al dettaglio del documento (gestito dal presente componente)
* Se l'utente è loggato accede, altrimenti deve eseguire la login (in questo caso l'url è xxxx\login\id)
*/

  ngOnInit() {
    if (this.isUserloggedIn) {
      this.activatedRoute.params.subscribe(p => {
        this.id = p['id'];
        console.log(this.id)
      });
    }

    //recupero i valori id utente /allegato nel caso di rating
    if (this.isUserloggedIn) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.idutente = params.idutente;
        this.idallegato = params.idallegato;
      });
    }
    console.log(this.idutente)
    this.loadedLogin = true;
  }

  checkIfLogin = () => {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let d = event.url.split('/');
        let m = d[d.length - 1];
        let n = d[d.length - 2];
        if (m != 'login') {
          this.authService.ImLogged(m,n).then(
            (result) => {
              if (result) {
                this.isUserloggedIn = true;
                this.profile = this.authService.getProfile();
                if (this.loadedLogin == true) {
                  this.activatedRoute.params.subscribe(p => {
                    this.id = p['id'];
                  });
                  this.activatedRoute.queryParams.subscribe(params => {
                    this.idutente = params.idutente;
                    this.idallegato = params.idallegato;
                  });
                  this.checkUtenteLoggato(this.idutente, this.id);
                }
              }
            },
            (error) => console.log('error')
          );
        }
      }
    });
  }

  /* Evolutive Maggio Giugno Luglio 2021: Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
    SubmitForm riceve [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]
    Ma per esigenze di rendering Link e Description link sono stati invertiti
    Modificato per le evolutive del Maggio 2023 per memorizzare su Arcadoc le letture dei link da parte degli utenti
    */

  submitForm = (values: string, iddocumento) => {
    if (values != null && values != undefined && values != "") {
      const valuesArray = values.split('**%%%%**');
      if (valuesArray[2] !== undefined) {
        this.DynamicFormElement.nativeElement.action = valuesArray[1];
        this.DynamicInputElement.nativeElement.value = valuesArray[2];
        this.DynamicFormElement.nativeElement.submit();
        let descrizioneLinkModified = valuesArray[0].replace("<u>", "").replace("</u>", "");
        let linkToCall = valuesArray[1];
        let url = 'api/rest/setLetturaLinkInternationalActivitiesInArcadoc';
        let input = { iddocumento: iddocumento, link: linkToCall, descrizionelink: descrizioneLinkModified };
        this.documentService.postData(url, input, false).subscribe(result => {
        }, error => console.error('error ', error));
      }
    }
  }

  getArcadocDocument(iddocumento) {
    let probeItem = new MetadatoTipologiaDto();
    let probeIndice = 0;
    const url = 'api/rest/getArcadocDocument';
    const input = { iddocumento: iddocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      console.log('this is document : ', result);
      let link1;
      let description1;
      let link2;
      let description2;
      let link3;
      let description3;
      this.document = result as Documento;
      this.document.isCollapsed = true;
      this.document.metadatiDtoList.forEach(item => {
        let count = 0;
        /* Traduzione delle label richiesta dal cliente: Traduco "a mano", queste label arrivano direttamente dal db di arcadoc e lì è pericoloso modificarle */
        let itemN = item.key.replace(/_/g, " ");
        let ItemEng = "";
        switch (itemN) {
          case "Data termine validita del documento":
            ItemEng = "Document validity end date";
            break;
          case "Stato del documento":
            ItemEng = "Status of the document";
            break;
          case "Status del documento":
            ItemEng = "Status of the document";
            break;
          case "Descrizione Link 1":
            ItemEng = "Description link 1";
            break;
          case "Descrizione link 1":
            ItemEng = "Description link 1";
            break;
          case "Descrizione Link 2":
            ItemEng = "Description link 2";
            break;
          case "Descrizione link 2":
            ItemEng = "Description link 2";
            break;
          case "Descrizione Link 3":
            ItemEng = "Description link 3";
            break;
          case "Descrizione link 3":
            ItemEng = "Description link 3";
            break;
          case "GlobalServiceMarketing":
            ItemEng = "Status of the document";
            break;
          default:
            ItemEng = itemN;
        }
        item.key = ItemEng;
        /* Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
        Nel seguente codice mi baso sul fatto che i campi arrivano in ordine per come sono nella tipologia in arcadoc:
        1: Link
        2: Description Link
        3: Password Link
        Link e Description sono memorizzati in due variabili. Quando passa Password Link rinomino la label (Key) in Description link e butto
        come valore (value) la stringa [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]. Nell'html mi curo di mandare a video solo la Description con uno split
        ma devo buttare tutti e tre i valori, perchè al click della description (ciò è richiesto dal cliente) dovrò inviare in un colpo solo Link e password a submitForm.
        Questa è la soluzione trovata per farlo dinamicamente per decine di record che sono letti da un foreach.
        */
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 1' && item.value != null && item.value != "" && item.value != undefined && item.value.trim() != "") {
          link1 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == ('description link 1') && item.value != null && item.value != undefined && item.value.trim() != "") {
          item.value = '<u>' + item.value + '</u>'
          description1 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
          let message = "";
          message = item.value.substring(15);
          message = message.substring(0, message.length - 14);
          console.log('message ' + message)
          message = this.Reverse(message);
          console.log('message ' + message)
          item.key = "Link 1 description";
          if (description1 == undefined && link1 != undefined) {
            description1 = '<u>Link</u>'
          } else if (description1 == undefined && link1 == undefined) {
            item.key = '';
          }
          item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + message;
          link1 = undefined;
          description1 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 1 description";
          item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
          link1 = undefined;
          description1 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 1 description";
          description1 = '<u>Link</u>'
          item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
          link1 = undefined;
          description1 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 1 description";
          item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
          link1 = undefined;
          description1 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = '';
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
          link2 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
          item.value = '<u>' + item.value + '</u>'
          description2 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
          let message = "";
          message = item.value.substring(15);
          message = message.substring(0, message.length - 14);
          message = this.Reverse(message);
          item.key = "Link 2 description";
          if (description2 == undefined && link2 != undefined) {
            description2 = '<u>Link</u>'
          } else if (description2 == undefined && link2 == undefined) {
            item.key = '';
          }
          item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + message;
          link2 = undefined;
          description2 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 2 description";
          item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
          link2 = undefined;
          description2 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 2 description";
          description2 = '<u>Link</u>'
          item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
          link2 = undefined;
          description2 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 2 description";
          item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
          link2 = undefined;
          description2 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = '';
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 3' && item.value != null && item.value != "" && item.value != undefined) {
          link3 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 3' && item.value != null && item.value != "" && item.value != undefined) {
          item.value = '<u>' + item.value + '</u>'
          description3 = item.value
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && item.value != null && item.value != "" && item.value != undefined && item.value.length > 19) {
          let message = "";
          message = item.value.substring(15);
          message = message.substring(0, message.length - 14);
          message = this.Reverse(message);
          item.key = "Link 3 description";
          if (description3 == undefined && link3 != undefined) {
            description3 = '<u>Link</u>'
          } else if (description3 == undefined && link3 == undefined) {
            item.key = '';
          }
          item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + message;
          link3 = undefined;
          description3 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 3 description";
          item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
          link3 = undefined;
          description3 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 3 description";
          description3 = '<u>Link</u>'
          item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
          link3 = undefined;
          description3 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = "Link 3 description";
          item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
          link3 = undefined;
          description3 = undefined;
        }
        if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
          item.key = '';
        }
        if (item.key === "Clinical application" && item.value.includes('_')) {
          this.isPreset = true;
          probeIndice = count + 1;
          probeItem = {
            key: "Correlated probe",
            value: item.value.split('_')[1]
          }
          item.value = item.value.split('_')[0];
        }
        count++;
      });
      if (probeIndice > 0 && probeItem.value !== null && probeItem.value !== undefined && probeItem.value !== "") {
        this.document.metadatiDtoList.splice(probeIndice, 0, probeItem);
      }
      this.document.bg = 'mat-card-header-gray';//this.bgColors[this.getRandomBgIndex()];
      this.document.active = 'titleTab';
      this.loaded = true;
    }, error => console.error('error ', error));
  }

  setFlagLetturaInArcadoc(iddocumento) {
    const url = 'api/rest/setFlagLetturaInArcadoc';
    const input = { iddocumento: iddocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
      console.log('Setflaglettura esguito: ' + result);
    }, error => console.error('error ', error));
  }

  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

  Reverse(str: string) {
    let newString = "";
    for (let i = str.length - 1; i >= 0; i--) {
      newString += str[i];
    }
    return newString;
  }

  getArcadocAttach(item: AttachmentDto, iddocumento, download: boolean) {
    const url = 'api/rest/GetAttachment';
    const needPresaVisione = this.documentService.isLegalEntityComplianceAssociated(this.document);
    const params = {
      params: {
        idAllegato: item.idAllegato,
        idDocument: iddocumento,
        fileName: item.nomeFile,
        download: download,
        needPresaVisione: needPresaVisione
      }
    };

    this.fileServer.getData(url, params, false).toPromise().then(res => {

      const attachment: AttachmentDto = res as AttachmentDto;

      if (needPresaVisione && attachment.presaVisione === false) {
        this.presaVisioneModalService.open(params.params.idDocument,
          params.params.idAllegato, params.params.download, params.params.fileName);
        return;
      }

      if (!this.hasAttachmentData(attachment)) {
        console.log("Impossibile recuperare l'allegato!");
        alert("Impossibile recuperare l'allegato!");
        return;
      }

      this.openAttachment(attachment, download);
    });
  }

  hasAttachments(): boolean {
    return this.hasPrimaryAttachment() || this.hasSecondaryAttachments();
  }

  hasPrimaryAttachment(): boolean {
    return this.isValidAttachment(this.document && this.document.allegatoPrimarioDto);
  }

  hasSecondaryAttachments(): boolean {
    return !!this.document &&
      !!this.document.allegatiSecondariDtoList &&
      this.document.allegatiSecondariDtoList.some(attachment => this.isValidAttachment(attachment));
  }

  private isValidAttachment(attachment: AttachmentDto): boolean {
    const idAllegato = attachment && attachment.idAllegato != null ? attachment.idAllegato.toString().trim() : '';

    return !!attachment &&
      ((typeof attachment.nomeFile === 'string' && attachment.nomeFile.trim() !== '') ||
        (idAllegato !== '' && idAllegato !== '0'));
  }

  private openAttachment(attachment: AttachmentDto, download: boolean): void {
    const ext = attachment.nomeFile.split('.').pop();
    const downloadLink = document.createElement("a");
    const fileName = attachment.nomeFile;

    this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
      const url = URL.createObjectURL(blob);
      if (download) {
        downloadLink.href = url;
        downloadLink.download = fileName;
        downloadLink.click();
      } else {
        window.open(url, '_blank')
      }
    })
  }

  private hasAttachmentData(attachment: AttachmentDto): boolean {
    return attachment != null && typeof attachment.data === 'string' && attachment.data.trim() !== '';
  }

  // Logica precedente mantenuta come riferimento: verificava la legal entity del documento tramite committente.
  // private isComplianceLegalEntity(): boolean {
  //   const legalEntity = this.getDocumentLegalEntity();
  //   return legalEntity !== '' && this.legalEntityService.isLegalEntityCompliance(legalEntity);
  // }

  // private getDocumentLegalEntity(): string {
  //   if (this.document && this.document.committente) {
  //     return this.document.committente.trim();
  //   }

  //   return '';
  // }

  checkUtenteLoggato(idutente: string, iddocumento: string) {
    let input = {};
    if (idutente == undefined) {
      input = { idutente: 0, iddocumento: iddocumento };
    } else {
      input = { idutente: idutente, iddocumento: iddocumento };
    }
    const url = 'api/rest/checkUtenteLoggato';
    this.documentService.postData(url, input, false).subscribe(result => {
      console.log(result)
      if (result['result'] == 'true') {
        this.getArcadocDocument(iddocumento);
        this.isUtenteChiamante = true;
      } else {
        this.isUtenteChiamante = false;
      }
    }, error => console.error('error ', error));
  }

  ApriRichiestaPassword(doc: Documento, Allegato: AttachmentDto, ArcaOperazione: boolean) {

    let isPreset = false;
    this.placeholder = 'Password';
    doc.metadatiDtoList.forEach(item => {

      let itemN = item.key.replace(/_/g, " ");
      item.key = itemN;

      if (item.key === "Clinical application" && item.value.includes('_')) {
        isPreset = true;
      }
    });

    if (isPreset) {
      this.RichiediPassword = true;
      this.ArcaOperazione = ArcaOperazione;
      this.DocAttesa = doc;
      this.AllegatoDtoAttesa = Allegato;

    } else {

      this.PasswordAllegato = ''
      this.RichiediPassword = false
      this.getArcadocAttach(doc.allegatoPrimarioDto, doc.idDocumento, this.ArcaOperazione);

    }
  }

  ConfermaPassword(cancel: boolean = false) {
    let PassArcaDoc = '';

    if (this.DocAttesa != undefined) {
      this.DocAttesa.metadatiDtoList.forEach(item => {
        let itemN = item.key.replace(/_/g, " ");
        item.key = itemN;
        //if (item.key === "Password Attachment") {
        if (item.key === "AttachmentCode") {
          PassArcaDoc = item.value;
        }
      });
      if (cancel) {
        this.RichiediPassword = false;

      } else if (this.PasswordAllegato == PassArcaDoc && !cancel) {
        this.getArcadocAttach(this.AllegatoDtoAttesa, this.DocAttesa.idDocumento, this.ArcaOperazione);

      } else {
       this.placeholder = 'Invalid entry';

      }
      this.PasswordAllegato = '';
    }
  }
}
